export default __webpack_public_path__ + "static/media/Envelope.46e33343.svg";